/**
 * Available maps in /public/assets/maps
 * Hardcoded to avoid bundling via import.meta.glob
 */
export const availableMaps = [
  { filename: 'forest.glb', path: 'assets/maps/forest.glb' },
  { filename: 'cave.glb', path: 'assets/maps/cave.glb' },
  { filename: 'supermarket.glb', path: 'assets/maps/supermarket.glb' },
  { filename: 'tooling-test.glb', path: 'assets/maps/tooling-test.glb' },
];
